import api from "./api";

const URLS = {
    impersonations: "impersonations",
    targets: "impersonation-targets",
};

// POST /impersonations — issue a token that acts as the target user.
export const startImpersonation = (userId) => {
    return api.post(URLS.impersonations, { user_id: userId });
};

// GET /impersonation-targets — paginated search of impersonatable accounts by
// email/head_email, by settlement ΑΜ ("company_id-serial"), or by entity id.
export const searchImpersonationTargets = (q, page = 1) => {
    return api.get(URLS.targets, { params: { q, page } });
};
